import { Component, OnInit, Output, ElementRef, EventEmitter, ViewChild } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-emoji-picker',
  templateUrl: './emoji-picker.component.html',
  styleUrls: ['./emoji-picker.component.css']
})
export class EmojiPickerComponent implements OnInit {
  isSeen: boolean = true;
  emojis: any;
  @Output() someEvent = new EventEmitter();
  @ViewChild("emojiPicker") emojiPicker: ElementRef;
  constructor() {
    this.emojis = environment.emojis;
  }
  selectEmoji(data) {
    this.someEvent.emit(data[0]);
  }
  blur() {
    this.isSeen = false;
  }
  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/directive/emoji-picker/emoji-picker.component.ts